export const LOOKUP_ROUTINES_TYPE = {
  CLONE: "CLONE",
  EDIT: "EDIT"
}
